export const VISIT_DOCUMENTS_TYPES = {
  CATEGORY: 'category',
  SUB_CATEGORY: 'subCategory',
  DOCUMENTS: 'documents',
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/AddDocumentForm/constants.js